<fgb-banner [bannerTitle]="'nav.gallery' | translate"></fgb-banner>

<fgb-page-header [pageTitle]="'nav.gallery'" [backButtonLink]="'/'" [showBalance]="false" [showQr]="false"></fgb-page-header>

<fgb-worksheet-list></fgb-worksheet-list>
